export const SCREEN_SIZES = Object.freeze({
  small: '(max-width: 64em)',
  medium: '(max-width: 108em)',
  large: '(min-width: 108em)',
});
